/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, Input, OnInit } from '@angular/core';
import { Logger } from '@app/core';
import { Company } from '@app/settings/companies/company.model';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CompaniesService } from '@app/settings/companies/companies.service';
import { ApiQuery } from '@app/core/http/api-query';
import { BankAccountsComponent } from '@app/shared/components/bank-accounts/bank-accounts.component';
import { ContactComponent } from '@app/shared/components/contact/contact.component';

const log = new Logger('companiesFormComponent');

@Component({
  selector: 'app-companies-form',
  templateUrl: './companies-form.component.html',
  styleUrls: ['./companies-form.component.scss'],
})
export class CompaniesFormComponent implements OnInit {
  @Input() company: Company = null;
  form: FormGroup;

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private companyService: CompaniesService
  ) {}

  ngOnInit() {
    this.createForm();
  }

  save() {
    if (this.company && this.company.id) {
      const company: Company = this.company.deserialize(this.form.value);
      this.companyService.update(company).subscribe((res) => this.modal.close(res));
    } else {
      const company: Company = new Company().deserialize(this.form.value);
      this.companyService.store(company).subscribe((res) => this.modal.close(res));
    }
  }

  test(form: any) {
    log.debug(form);
  }

  private createForm() {
    this.form = this.formBuilder.group({
      name: [null, [Validators.required]],
      city_id: [null, [Validators.required]],
      city: [null],
      logo: [null],
      new_logo: [null],
      color: ['#ffffff', [Validators.required]],
      contacts: new FormArray([]),
      address: [null, [Validators.required]],
      abbreviation: [null, [Validators.required]],
      registration_number: [null, [Validators.required]],
      tax_number: [null, [Validators.required]],
      vat_number: [null, [Validators.required]],
      iata_tids_number: [null, [Validators.required]],
      active: [true],

      vat_percent: [null],
      proforma_prefix: [null],
      invoice_digits_count: [null],
    });

    if (this.company && this.company.id) {
      const query = new ApiQuery();
      query.addIncludes('city.country', 'contacts', 'logo');
      this.companyService.show(this.company.id, query).subscribe((company: Company) => {
        if (company['contacts'].length > 0) {
          this.form.setControl('contacts', ContactComponent.createMany(company['contacts']));
        }
        this.form.patchValue(company);
      });
    } else if (this.company) {
      this.form.patchValue(this.company);
    }
  }
}
